import 'tifosy'

import tifosyCloudinary from 'tifosy_cloudinary'

document.addEventListener('turbo:load', (event) => {
  tifosyCloudinary.responsive()
})
